import api from './index'

export function getMainDisplay() {
  return api.get('/api/v1/main-display')
}
